export default "__VITE_ASSET__c1f60562__"